import { createContext, useContext, useRef } from 'react';

interface ModalsActionsRef {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onInfoModalOpen?: (data: any) => void;
}

interface ModalActionsContext {
    modalActionsRef: React.MutableRefObject<ModalsActionsRef>;
}

const modalActionsContext = createContext<Nullable<ModalActionsContext>>(null);

export const ModalActionsContextProvider: React.FC = ({ children }) => {
    const modalActionsRef = useRef<ModalsActionsRef>({});
    return <modalActionsContext.Provider value={{ modalActionsRef }}>{children}</modalActionsContext.Provider>;
};

export const useModalActionsContext = () => {
    const context = useContext(modalActionsContext);
    if (!context) {
        throw new Error('useModalActionsContext must be used within a ModalActionsContextProvider');
    }
    return context;
};
